import React from 'react';
import './Terms.css';
const Terms: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="terms-header">
        <div className="container">
          <div className="terms-logo">
            <img src="/choretap-logo.png" alt="ChoreTap Logo" />
          </div>
          <h1>Terms of Service</h1>
          <p className="terms-subtitle">
            Please read these terms carefully before using ChoreTap.
          </p>
        </div>
      </div>
      <div className="terms-content">
        <div className="container">
          <p className="last-updated">Last updated: April 8, 2026</p>
          <div className="terms-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using ChoreTap, you accept and agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our service.
              These terms apply to all users of the app, including parents, guardians, and children under supervision.
            </p>
          </div>
          <div className="terms-section">
            <h2>Account Registration</h2>
            <p>
              To use ChoreTap, you must create an account and provide accurate, complete information.
              You are responsible for maintaining the security of your account credentials.
              Parents or guardians must be at least 18 years old to create an account.
              You agree to notify us immediately of any unauthorized access to your account.
            </p>
          </div>
          <div className="terms-section">
            <h2>Parental Responsibility</h2>
            <p>
              ChoreTap is designed for family use under parental supervision.
              Parents or guardians are responsible for monitoring their children's use of the app.
              You are responsible for all activities that occur under your family account.
              Parents control all payment features and must supervise any financial transactions.
            </p>
          </div>
          <div className="terms-section">
            <h2>Service Usage</h2>
            <p>
              You agree to use ChoreTap only for lawful purposes and in accordance with these Terms.
              You will not use the service to harm, harass, or violate the rights of others.
              We reserve the right to suspend or terminate accounts that violate these terms.
              The service is provided "as is" and we make no guarantees about availability or functionality.
            </p>
          </div>
          <div className="terms-section">
            <h2>Payment and Subscriptions</h2>
            <p>
              Some features of ChoreTap may require payment or subscription.
              All fees are clearly disclosed before purchase and are non-refundable unless required by law.
              Subscriptions automatically renew unless cancelled before the renewal date.
              You can manage your subscription through your app store account settings.
            </p>
          </div>
          <div className="terms-section">
            <h2>User Content</h2>
            <p>
              You retain ownership of any content you create or upload to ChoreTap.
              By using our service, you grant us a license to use, store, and display your content as necessary to provide the service.
              You are responsible for ensuring that your content does not violate any laws or third-party rights.
              We reserve the right to remove content that violates these terms or applicable laws.
            </p>
          </div>
          <div className="terms-section">
            <h2>Intellectual Property</h2>
            <p>
              ChoreTap and all its original content, features, and functionality are owned by ChoreTap and are protected by copyright, trademark, and other intellectual property laws.
              You may not copy, modify, distribute, or create derivative works from our service without permission.
            </p>
          </div>
          <div className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, ChoreTap shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
              Our total liability to you for any claims related to the service shall not exceed the amount you paid us in the past 12 months.
              Some jurisdictions do not allow the exclusion of certain warranties or limitations of liability, so these limitations may not apply to you.
            </p>
          </div>
          <div className="terms-section">
            <h2>Termination</h2>
            <p>
              You may terminate your account at any time through the app settings.
              We reserve the right to terminate or suspend your account for violations of these Terms.
              Upon termination, your right to use the service will immediately cease.
              Data retention after termination is governed by our Privacy Policy.
            </p>
          </div>
          <div className="terms-section">
            <h2>Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time.
              We will notify you of any significant changes through the app or via email.
              Your continued use of ChoreTap after changes are posted constitutes acceptance of the updated terms.
            </p>
          </div>
          <div className="terms-section">
            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which ChoreTap operates,
              without regard to its conflict of law provisions.
            </p>
          </div>
          <div className="terms-section contact-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about these Terms of Service, please contact us at{' '}
              <a href="mailto:support@choretap.app">support@choretap.app</a>.
            </p>
          </div>
        </div>
      </div>
      <div className="terms-footer">
        <div className="container">
          <a href="/" className="back-home">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};
export default Terms;
